<template>
	<div class="container">
		<div class="main">
			<div class="login-box flex flex-c" v-if="step == 1">
				<div class="topTitle">欢迎来到S学苑</div>
				<div class="subTitle">{{loginType==1?'请输入手机号进行登录':'请使用微信扫码登录'}}</div>
				<div class="edit-main flex flex-c" v-if="loginType==1">
					<div class="inputbg flex">
						<img src="../assets/images/login/sj.png" style="width: 20px;height: 20px;" />
						<el-dropdown  @command='selectCode'>
							<div class="areacode pointer">{{areaCode}}</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command='+86'>+86</el-dropdown-item>
								<el-dropdown-item command='+886'>+886</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<input class="input" @input="phoneChange" v-model="phone" placeholder="请输入手机号"
							autocomplete="new-password">
					</div>
					<div class="inputbg flex" style="margin-top: 21px;">
						<img src="../assets/images/login/mm.png" style="width: 20px;height: 20px;" />
						<input class="input" v-model="code" type="input" placeholder="请输入验证码"
							autocomplete="new-password">
						<div class="code" v-if="seconds == 60" @click="sendCode">获取验证码</div>
						<div class="sec" v-else>{{seconds}}s后再次获取</div>
					</div>
					<div class="tips pointer">登录即代表同意 <span style="color: #00A73C;"
							@click="$router.push('/content?source=1')">《用户协议》</span>
						<span style="color: #00A73C;" @click="$router.push('/content?source=2')">《隐私条款》</span>
					</div>
					<div class="tips1">未注册用户登录后将自动进行注册</div>
					<div class="login-btn pointer" v-if="!login_data" @click="onLogin">
						<span class="text">登 录</span>
					</div>
					<div class="wxbtn pointer" @click="wxLogin">微信登录</div>
					<!-- <div class="wxbtn pointer" v-if="login_data" @click="WechatLoginBindPhoneFunc()">绑定手机号</div> -->
				</div>

				<div class="edit-main flex flex-c" style="margin-top: 22px;" v-if="loginType==2">
					<!-- <div style="width: 262px;height: 262px;" id="wechat-login-container"></div> -->
					<wxlogin
					      appid="wx2cf2f1cec3852ce1"
					      :scope="'snsapi_login'"
					      :redirect_uri="encodedRedirectUri"
					      theme="black"
					    />
					<div class="tips pointer" style="margin-top: 18px;">登录即代表同意 <span style="color: #00A73C;"
							@click="$router.push('/content?source=1')">《用户协议》</span>
						<span style="color: #00A73C;" @click="$router.push('/content?source=2')">《隐私条款》</span>
					</div>
					<div class="tips1">未注册用户登录后将自动进行注册</div>
					<div class="flex pointer shj" style="margin-top: 38px;" @click="loginType = 1">
						<img src="../assets/images/login/qh.png" style="width: 18px;height: 18px;margin-right: 4px;" />
						<span>切换手机号登陆</span>
					</div>
				</div>
			</div>
			<div class="login-box" v-if="step == 2">
				<div class="flex">
					<img src="../assets/icon/back.png" @click="step = 1" class="pointer"
						style="width: 22px;height: 22px;" />
					<div style="margin-left: 13px;">
						<div class="yqtext">邀请码填写</div>
						<div class="yq">请输入推荐人邀请码，如没有推荐人，请跳过</div>
					</div>
				</div>
				<div class="edit-main flex flex-c">
					<div class="inputbg flex" style="margin-top: 21px;">
						<img src="../assets/images/login/yqm.png" style="width: 22px;height: 22px;" />
						<input class="input" v-model="invite_code" type="text" placeholder="请输入6位邀请码"
							autocomplete="new-password">
					</div>
					<div class="login-btn pointer" style="margin-top: 62px;" @click="setInviteClick">
						<span class="text">登 录</span>
					</div>
					<div class="wxbtn pointer" @click="dialogVisible = true">跳 过</div>
				</div>
			</div>
		</div>

		<el-dialog :visible.sync="dialogVisible" :show-close='false' :close-on-click-modal='false'
			:close-on-press-escape='false' width="356px">
			<div class="tcbg flex flex-c" v-if="loginUser.member">
				<img :src="loginUser.member.img" style="width: 105px;height: auto;" />
				<div class="ht">尊贵的（{{loginUser.member?loginUser.member.name:''}}）会员</div>
				<div class="ht1">请开始您的学习吧！</div>
				<div class="btn flex flex-c-c pointer" @click="toPageHome">
					<div class="te">进入S学苑</div>
					<img src="../assets/images/login/right.png" style="width: 7px;height: 9px;margin-left: 7px;" />
				</div>
			</div>
			<div class="tcbg flex flex-c" v-else>
				<div class="ht">尊贵的（{{loginUser.name}}）</div>
				<div class="ht1">请开始您的学习吧！</div>
				<div class="btn flex flex-c-c pointer" @click="toPageHome">
					<div class="te">进入S学苑</div>
					<img src="../assets/images/login/right.png" style="width: 7px;height: 9px;margin-left: 7px;" />
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import wxlogin from 'vue-wxlogin';
	import {
		_debounce
	} from "@/configs/public"
	import {
		encrypt
	} from "@/filters/filter";
	import {
		login,
		setInvite,
		WechatLogin,
		WechatLoginBindPhone
	} from "@/api/common";
	import {
		getMyCourse,
		getUser,
		EditUser,
		UserSetFirstLogin,
		SendSmsCode
	} from '@/api/mine';
	import {
		pms2MenuList
	} from "../filters/filter";
	import Utils from "@/jslibs/utils";
	import {
		mapMutations,
		mapActions
	} from "vuex";
	// import { LimitsList } from '@/api/auth'
	export default {
		components: {
			wxlogin
		},
		data() {
			return {
				encodedRedirectUri:'https://academy-pc.gymooit.cn',
				dialogVisible: false,
				loginType: 1,
				step: 1,
				forgetShow: false,
				checked: false,
				invite_code: '',
				inputCode: "",
				phone: "",
				code: "",
				rules: [],
				permissionList: [],
				loginUser: '',
				shareInviteCode: '',
				seconds: 60,
				areaCode:'+86',
				login_data:''
			};
		},

		created() {},

		mounted() {
			let loginAccount = localStorage.getItem('loginAccount')
			let loginPassword = localStorage.getItem('loginPassword')
			this.shareInviteCode = this.$route.query.shareInviteCode
			if (loginAccount && loginPassword) {
				this.name = loginAccount
				this.password = loginPassword
				this.checked = true
			}
			if(this.$route.query.code){
				this.WechatLoginFunc(this.$route.query.code)
			}
		},
		methods: {
			async WechatLoginFunc(code){
				const {
					status,
					data
				} = await WechatLogin({
					code:code,
					type:2,
					invite_code:this.shareInviteCode
				})
				if (status != 200) {
					this.login_data = data.error.data.login_data
					this.WechatLoginBindPhoneFunc()
					return
				}
				this.loginUser = data.result.user
				Utils.setCookie("authorization", data.result.token, 7); // TODO: 先设三天过期
				this.getUser()
				this.UserSetFirstLogin()
			},
			async WechatLoginBindPhoneFunc(){
				const {
					status,
					data
				} = await WechatLoginBindPhone({
					login_data:this.login_data,
					phone:this.areaCode+this.phone,
					phone_code: this.code,
					invite_code:this.shareInviteCode,
					type:2,
				})
				if (status != 200) return
				this.loginUser = data.result.user
				Utils.setCookie("authorization", data.result.token, 7); // TODO: 先设三天过期
				this.getUser()
				this.UserSetFirstLogin()
			},
			async wxLogin(){
				this.loginType = 2
			},
			selectCode(e){
				this.areaCode = e
			},
			sendCode: _debounce(function(_type, index, item) {
				this.sendCodeApi();
			}, 200),
			async sendCodeApi() {
				if (!this.phone) {
					this.$message({
						message: "请输入手机号",
						type: "warning"
					});
					return
				}
				this.resetCode()
				const {
					status,
					data
				} = await SendSmsCode({
					phone: this.areaCode+this.phone,
				})
				if (status != 200) return
				this.$message({
					message: "发送成功",
					type: "success"
				});
			},
			resetCode() {
				this.seconds -= 1
				let interval = setInterval(() => {
					if (this.seconds > 0) {
						this.seconds -= 1
					} else {
						this.seconds = 60
						clearInterval(interval)
					}
				}, 1000)
			},
			async setInviteClick() {
				if (!this.invite_code) {
					this.$message({
						message: "请输入邀请码",
						type: "warning"
					});
					return
				}
				const {
					status,
					data
				} = await setInvite({
					code: this.invite_code,
				});
				if (status != 200) return
				// this.$message({
				// 	message: "绑定成功",
				// 	type: "success"
				// });
				this.dialogVisible = true
			},
			async getUser() {
				let that = this
				const {
					status,
					data
				} = await getUser({})
				this.loginUser = data.result
				Utils.setCookie("loginUser", JSON.stringify(this.loginUser), 7); // TODO: 先设三天过期  */

				if (that.shareInviteCode) {
					that.dialogVisible = true
				} else {
					if (that.loginUser.first_login == 1) {
						that.step = 2
					} else {
						that.dialogVisible = true
					}
				}

				// if (this.loginUser.is_new != 1) {
				// 	this.dialogVisible = true
				// } else {
				// 	this.step = 2
				// }
			},
			async onLogin() {
				if (!this.phone) {
					this.$message({
						message: "请输入手机号",
						type: "warning"
					});
					return
				}
				if (!this.code) {
					this.$message({
						message: "请输入验证码",
						type: "warning"
					});
					return
				}
				const {
					status,
					data
				} = await login({
					phone: this.areaCode+this.phone,
					code: this.code,
					invite_code: this.shareInviteCode
				});
				if (status != 200) return
				// this.$message({
				// 	message: "登录成功",
				// 	type: "success"
				// });
				this.loginUser = data.result.user
				Utils.setCookie("authorization", data.result.token, 7); // TODO: 先设三天过期
				this.getUser()
				this.UserSetFirstLogin()
			},
			async UserSetFirstLogin() {
				const {
					status,
					data
				} = await UserSetFirstLogin({});
			},
			toPageHome() {
				this.dialogVisible = false
				this.$router.push("/index");
			},
			phoneChange(e) {
				this.name = this.formatPhone(e.target.value)
			},
			formatPhone(phone) {
				return phone.replace(/\D/g, '') // 移除非数字字符
					.replace(/(\d{3})(?=\d)/g, '$1 '); // 每3位后加空格
			},
			restorePhoneNumber(formattedPhone) {
				return formattedPhone.replace(/\s/g, ''); // 移除所有空格
			},
			...mapMutations([
				"update_operation_list",
				"update_permission_list",
				"updateLoginData"
			]),
			...mapActions(["getCommonInfo"]),
			event() {
				const self = this;
				return {
					onVerifyImgClicked() {
						self.handler().refreshCode();
					},
					onLogin: () => {
						this.network().addlogin();
					}
				};
			},

		},
		watch: {},
		computed: {}
	};
</script>

<style scoped lang="less">
	.container {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100vh;
		background: url('../assets/images/login/bg.png') no-repeat;
		background-size: 100% 100%;

		.main {
			flex: 1;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;

			.login-box {
				width: 409px;
				background: #FFFFFF;
				border-radius: 13px 13px 13px 13px;
				padding: 36px 27px 28px 27px;
				box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);

				.topTitle {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 500;
					font-size: 20px;
					color: #333333;
				}

				.subTitle {
					margin-top: 13px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 300;
					font-size: 16px;
					color: #333333;
				}


				.edit-main {
					margin-top: 51px;

					.inputbg {
						width: 356px;
						height: 53px;
						background: #FFFFFF;
						border-radius: 13px 13px 13px 13px;
						padding: 16px 18px;
						border: 1px solid #EEEEEE;
						position: relative;

						.code {
							font-family: HONOR Sans CN, HONOR Sans CN;
							font-weight: 400;
							font-size: 14px;
							color: #EACF8C;
							white-space: nowrap;
							position: absolute;
							right: 18px;
							cursor: pointer;
						}

						.sec {
							font-family: HONOR Sans CN, HONOR Sans CN;
							font-weight: 500;
							font-size: 14px;
							color: #CCCCCC;
							position: absolute;
							right: 18px;
							cursor: pointer;
						}
					}

					.inputbg:hover {
						border: 1px solid #00A73C;
					}

					.inputbg:focus:hover {
						border: 1px solid #00A73C;
					}

					.areacode {
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 500;
						font-size: 16px;
						color: #666666;
						margin-left: 13px;
					}

					.input {
						padding: 0 14px;
						outline: none;
						border: none;
						font-size: 16px;
						background: transparent;
						font-weight: 400;
						color: #000;
						font-family: HONOR Sans CN, HONOR Sans CN;
					}

					.input::placeholder {
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 400;
						font-size: 16px;
						color: #999999;
					}

					.login-btn {
						width: 364px;
						height: 59px;
						background: url('../assets/images/login/loginbtn.png') no-repeat;
						background-size: 100% 100%;
						margin-top: 13px;
						display: flex;
						align-items: center;
						justify-content: center;

						.text {
							font-family: HONOR Sans CN, HONOR Sans CN;
							font-weight: 600;
							font-size: 16px;
							text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
							text-align: center;
							font-style: normal;
							text-transform: none;
							background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
							-webkit-background-clip: text;
							-webkit-text-fill-color: transparent;
						}
					}

					.wxbtn {
						margin-top: 18px;
						width: 360px;
						height: 51px;
						border-radius: 12px 12px 12px 12px;
						border: 2px solid rgba(127, 218, 76, .24);
						display: flex;
						align-items: center;
						justify-content: center;
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 400;
						font-size: 16px;
						text-align: center;
						font-style: normal;
						text-transform: none;
						background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
						-webkit-background-clip: text;
						-webkit-text-fill-color: transparent;
					}
				}
			}
		}

	}

	/deep/input:-internal-autofill-selected {
		background-color: none !important;
	}

	.tips {
		margin-top: 48px;
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 13px;
		color: #333333;
	}

	.tips1 {
		margin-top: 4px;
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 13px;
		color: #999999;
	}

	.yqtext {
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 500;
		font-size: 20px;
		color: #333333;
	}

	.yq {
		margin-top: 13px;
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 300;
		font-size: 16px;
		color: #333333;
	}

	.shj {
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 16px;
		background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	/deep/ .el-dialog__header {
		padding: 0 !important;
	}

	.tcbg {
		.ht {
			margin-top: 23px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 18px;
			color: #333333;
		}

		.ht1 {
			margin-top: 7px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #666666;
		}

		.btn {
			margin-top: 29px;
			width: 276px;
			height: 50px;
			background: url('../assets/images/login/loginbtn.png') no-repeat;
			background-size: 100% 100%;

			.te {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 16px;
				text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
				text-align: center;
				background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
			}
		}
	}

	/deep/ .el-dialog {
		border-radius: 18px !important;
	}
</style>